import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ContactService {

  constructor(private http: HttpClient) { }

  getCount(filter): Observable<any> {
    return this.http
      .post(
        `/api/v1/contact/count`,
        JSON.stringify(filter)
      );
  }

  getPaginated(filter): Observable<any> {
    return this.http
      .post(
        `/api/v1/contact/paginate`,
        JSON.stringify(filter)
      );
  }

  getExport(filter): Observable<any> {
    return this.http
      .post(
        `/api/v1/contact/export`,
        JSON.stringify(filter),
        { responseType: 'text' }
      );
  }

  findByEmail(emailAddress: string) {
    return this.http
      .post(
        `/api/v1/contact/search`,
        JSON.stringify({ email_address: emailAddress })
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/contact.service.ts